module.exports = __webpack_public_path__ + "static/img/14.28b89dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/14.png
// module id = ILz8
// module chunks = 0